import { useEffect } from 'react';
import { AUTOSCROLL_THRESHOLD_WIDTH, FRAME_WIDTH } from '../../constants';
import type { ApplyFramePositionT } from '../../types';
type UseAnimateOnCurrentFrameChangePropsT = {
  frame: number;
  lastFrameRef: React.MutableRefObject<number>;
  applyFramePosition: ApplyFramePositionT;
  gridContainer: HTMLDivElement | null;
};
export function useAnimateOnCurrentFrameChange({
  frame,
  lastFrameRef,
  applyFramePosition,
  gridContainer
}: UseAnimateOnCurrentFrameChangePropsT) {
  useEffect(() => {
    if (frame === lastFrameRef.current) {
      return;
    }
    lastFrameRef.current = frame;
    applyFramePosition(gridContainer?.scrollLeft || 0);

    // Scroll the grid, if current frame marker goes outside the grid
    if (!gridContainer) {
      return;
    }
    const containerWidth = gridContainer.clientWidth;
    const containerLeftEdge = gridContainer.scrollLeft;
    const containerRightEdge = containerLeftEdge + containerWidth;
    const markerPosition = frame * FRAME_WIDTH + FRAME_WIDTH / 2;
    if (markerPosition - containerLeftEdge < AUTOSCROLL_THRESHOLD_WIDTH) {
      // If marker is going outside of left edge + threshold, scroll to left.
      // Decrease scrollLeft by the threshold to a minimum of zero.
      // eslint-disable-next-line react-hooks/immutability
      gridContainer.scrollLeft = Math.max(0, markerPosition - AUTOSCROLL_THRESHOLD_WIDTH);
    } else if (containerRightEdge - markerPosition < AUTOSCROLL_THRESHOLD_WIDTH) {
      // If marker is going outside of right edge + threshold, scroll to right.
      // Maximum of scrollLeft is total scrollWidth - containerWidth.
      // Increase scrollLeft by adding threshold to marker position so marker is always
      // visible.
      gridContainer.scrollLeft = Math.min(gridContainer.scrollWidth - containerWidth, markerPosition + AUTOSCROLL_THRESHOLD_WIDTH - containerWidth);
    }
  }, [applyFramePosition, frame, lastFrameRef, gridContainer]);
}